import { Field } from "typegraph";

export default class LaunchURL {

	@Field()
	public id: string;

	@Field()
	public launchURL: null | string;

}



// WEBPACK FOOTER //
// ./src/common/entities/LaunchURL.ts